import TravelSeriesPlaylist from './TravelSeriesPlaylist';

export default TravelSeriesPlaylist;
